// export const NET_BASE_URL = 'https://testchat.caiguayun.com'
// export const BASE_URL = 'https://testkefu.caiguayun.com/cgapitest'
// export const BASE_URL_KEFU = 'https://testkefu.caiguayun.com'

export const NET_BASE_URL = 'https://chat.caiguayun.com'
export const BASE_URL = 'https://kefu.caiguayun.com/cgapitest'
export const BASE_URL_KEFU = 'https://kefu.caiguayun.com'
// 调试配置
export const DEBUG_CONFIG = {
  ENABLE_IMAGE_DEBUG: true, // 启用图片路径调试
  LOG_LEVEL: 'info' // 日志级别: debug, info, warning, error
};

// API 基础配置
export const API_CONFIG = {
  BASE_URL: '/cgapitest',
  TIMEOUT: 60000,
  VERSION: '1.0.0'
};

// 本地存储的 key
export const STORAGE_KEYS = {
  USER_INFO: 'k_userInfo',
  REMEMBER_USERNAME: 'k_saved_username',
  REMEMBER_PASSWORD: 'k_saved_password'
};

// 响应状态码
export const RESPONSE_CODE = {
  SUCCESS: 1,
  ERROR: -1,
  LOGINOUT: 999,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404
};

// 全局常量
export const CONSTANTS = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif'],
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss'
};

// 全局方法

/**
 * 格式化日期
 * @param {Date|string|number} date 日期对象或时间戳
 * @param {string} format 格式化模板
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, format = CONSTANTS.DATE_FORMAT) => {
  date = date instanceof Date ? date : new Date(date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

/**
 * 加密工具
 * 使用 AES 加密算法
 */
const CryptoKey = 'CAIGUA_KEFU_2024'; // 加密密钥

export const crypto = {
  // 加密方法
  encrypt(text) {
    if (!text) return '';
    // 简单的凯撒密码加密，实际项目中建议使用更安全的加密方法
    let txt = text + ''
    return txt.split('').map(char => {
      return String.fromCharCode(char.charCodeAt(0) + 3);
    }).join('');
  },

  // 解密方法
  decrypt(text) {
    if (!text) return '';
    // 凯撒密码解密
    return text.split('').map(char => {
      return String.fromCharCode(char.charCodeAt(0) - 3);
    }).join('');
  }
};

// 修改 storage 对象，添加加密存储方法
export const storage = {
  set(key, value, encrypt = false) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    if (encrypt) {
      value = crypto.encrypt(value);
    }
    localStorage.setItem(key, value);
  },
  
  get(key, decrypt = false) {
    let value = localStorage.getItem(key);
    if (!value) return null;
    
    if (decrypt) {
      value = crypto.decrypt(value);
    }
    
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  
  remove(key) {
    localStorage.removeItem(key);
  },
  
  clear() {
    localStorage.clear();
  }
};

/**
 * 检查用户是否已登录
 * @returns {boolean}
 */
export const checkLogin = () => {
  const userInfo = storage.get(STORAGE_KEYS.USER_INFO);
  const token = storage.get(STORAGE_KEYS.TOKEN);
  return !!(userInfo && token);
};

/**
 * 文件大小格式化
 * @param {number} bytes 字节数
 * @returns {string} 格式化后的大小
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * 防抖函数
 * @param {Function} fn 要执行的函数
 * @param {number} delay 延迟时间
 * @returns {Function} 防抖后的函数
 */
export const debounce = (fn, delay = 300) => {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

/**
 * 节流函数
 * @param {Function} fn 要执行的函数
 * @param {number} interval 间隔时间
 * @returns {Function} 节流后的函数
 */
export const throttle = (fn, interval = 300) => {
  let last = 0;
  return function (...args) {
    const now = Date.now();
    if (now - last >= interval) {
      last = now;
      fn.apply(this, args);
    }
  };
};

/**
 * 深拷贝
 * @param {*} obj 要拷贝的对象
 * @returns {*} 拷贝后的对象
 */
export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  const clone = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clone[key] = deepClone(obj[key]);
    }
  }
  return clone;
};

/**
 * 获取URL参数
 * @param {string} name 参数名
 * @returns {string|null} 参数值
 */
export const getUrlParam = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};

/**
 * 生成随机字符串
 * @param {number} length 字符串长度
 * @returns {string} 随机字符串
 */
export const randomString = (length = 32) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const convertNetLinkHead = (link) => {
  if (link == null || link == undefined || link == '') {
    return ''
  }
  // 使用 console.log 直接输出，因为 preload.js 已经重定向了 console 输出
  if (link && link != null && link != undefined && link != '') {
    let newLink = link + ''
    if (newLink.startsWith("//")) {
      return "https:" + newLink
    }
  }

  let imgPath = getImagePath(link)
  return imgPath
}

/**
 * 处理图片路径，确保在Electron环境中能正确加载
 * @param {string} imgPath - 图片路径
 * @returns {string} - 处理后的图片路径
 */
export function getImagePath(imgPath) {
  // 如果是空值，返回空字符串
  if (!imgPath || imgPath === null || imgPath === undefined || imgPath === '') {
    return '';
  }

  // 如果是完整URL或数据URL，直接返回
  if (imgPath.startsWith('http') || imgPath.startsWith('data:') || imgPath.startsWith('blob:') || imgPath.startsWith('file:')) {
    return imgPath;
  }
    
  // 如果是在Electron环境中
  if (window.electron) {
    
    // 如果electron对象中有getResourcePath方法，使用它
    if (typeof window.electron.getResourcePath === 'function') {
      return window.electron.getResourcePath(imgPath);
    }
    
    // 否则使用简单的file://协议处理
    // 确保路径有正确的前缀
    if (!imgPath.startsWith('/')) {
      imgPath = '/' + imgPath;
    }
    
    // 处理/public/ 或 /img/ 开头的路径
    if (imgPath.startsWith('/public/') || imgPath.startsWith('/img/') || imgPath.startsWith('/images/')) {
      // 确保使用正确的文件协议格式
      if (!imgPath.startsWith('file://')) {
        // 在Windows环境下需要额外添加一个/来形成正确的file:///格式
        imgPath = "file:///" + imgPath.replace(/^\//,'');
        console.log('转换为文件协议路径:', imgPath);
      }
    }
  }
  
  // 其他情况直接返回原路径
  return imgPath;
}

// 导出默认对象，包含所有工具方法
export default {
  NET_BASE_URL,
  BASE_URL,
  API_CONFIG,
  STORAGE_KEYS,
  RESPONSE_CODE,
  CONSTANTS,
  formatDate,
  storage,
  crypto,
  checkLogin,
  formatFileSize,
  debounce,
  throttle,
  deepClone,
  getUrlParam,
  randomString,
  convertNetLinkHead,
  getImagePath
};
